import React, { useEffect, useState, useReducer } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import { setSnackBarAlert, caughtError, findAllTeams } from '../../redux';
import getAppConfig from '../../config';
const config = getAppConfig();

const initialState = {
   teamName: '',
   colorCode: '#FF8C00',
   groupId: '',
   active: false
}

const reducer = (state, action) => {
  return {
  ...state,
  ...action
  }
}

const EditForm = (props) => {

  const [state, updateState] = useReducer(reducer, initialState);
  const [loading, setLoading] = useState(true);
  const [btnDisabled, setBtnDisabled] = useState(true);
  const dispatch = useDispatch();

  const handleInputChange = (event) => {
    if(event.target.type === 'checkbox'){
      updateState({ [event.target.name]: event.target.checked });
    } else {
      updateState({ [event.target.name]: event.target.value });
    }
  }

  useEffect(() => {
    if(loading && props.modalDiaLogId && props.modalDiaLogId > 0) {
      let URL = `${config.api.URL}/team/${props.modalDiaLogId}`;
      axios.get(URL).then(response => {

        updateState({
          teamName: response.data.data.teamName,
          colorCode: response.data.data.colorCode,
          groupId: response.data.data.groupId,
          active: Boolean(response.data.data.active)
        })

        setBtnDisabled(false);
        setLoading(false);
      }).catch(error => {
        setLoading(false);
        console.log(error);
      })
    }
  }, [loading, props]);

  const handleSubmit = (event) => {
    event.preventDefault();
    setBtnDisabled(true);

    const input = {
      teamName: state.teamName,
      colorCode: state.colorCode ? state.colorCode : '#FF8C00',
      active: state.active,
      groupId: state.groupId
    }

    axios.patch(`${config.api.URL}/team/${props.modalDiaLogId}`,input).then(response => {
      dispatch(setSnackBarAlert({
        openSnackBar: true,
        severity: 'success',
        message: `Success! ${state.teamName} team updated`
      }));
      dispatch(findAllTeams(props.filterInput));
      props.setOpen(false);
    }).catch(error => {
      setBtnDisabled(false);
      dispatch(caughtError(error));
    })

  }

  const teamGroupData = props.teamGroup.data;
  let teamGroupSelect = <MenuItem value={''}>NONE</MenuItem>
  if(teamGroupData.length > 0) {
    teamGroupSelect = teamGroupData.map( (row) => <MenuItem key={row.id} value={row.id}>{row.groupName}</MenuItem>)
  }

  return (
    <form onSubmit={handleSubmit}>
      <DialogContent sx={{ marginTop: "-20px" }} >

        <div className="row">

            <div className="col-12">
              <TextField
                value={state.teamName}
                onChange={handleInputChange}
                name="teamName"
                label="Team Name"
                margin="dense"
                type="text"
                fullWidth
                variant="outlined"
                required
              />
            </div>
            <div className="col-12">
              <FormControl fullWidth style={{ marginTop: '8px' }}>
                <InputLabel>TeamGroup</InputLabel>
                <Select
                  name="groupId"
                  label="TeamGroup"
                  variant="outlined"
                  margin="dense"
                  value={state.groupId}
                  onChange={handleInputChange}
                  required
                >
                  {teamGroupSelect}
                </Select>
              </FormControl>
            </div>
            <div className="col-12">
              <TextField
                autoFocus
                value={state.colorCode}
                onChange={handleInputChange}
                name="colorCode"
                label="colorCode"
                margin="dense"
                type="text"
                fullWidth
                variant="outlined"
                required
              />
            </div>
            <div className="col-12">
            <FormControlLabel
              control={<Switch name="active"  checked={state.active}  onChange={handleInputChange} />}
              label="Active"
              labelPlacement="end" />
            </div>

        </div>

      </DialogContent>
      <DialogActions>
        <button className="btn btn-secondary" onClick={ (e) => {
            e.preventDefault();
            props.setOpen(false);
          } }>Cancel</button>
        <button disabled={btnDisabled} type="submit" className="btn btn-primary" >Update Team</button>
      </DialogActions>
    </form>
  )

}


export default EditForm;
